import { render, staticRenderFns } from "./WebAppUserBond.vue?vue&type=template&id=525571af&scoped=true&"
import script from "./WebAppUserBond.vue?vue&type=script&lang=js&"
export * from "./WebAppUserBond.vue?vue&type=script&lang=js&"
import style0 from "./WebAppUserBond.vue?vue&type=style&index=0&id=525571af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525571af",
  null
  
)

export default component.exports